<template>
<div class="wrapper fieldCheckBoxWrapper">
  <div :class="{ 'added fieldCheckBoxObjectArray': item.kubik, 'fieldCheckBoxObjectArray': !item.kubik} " v-for="(item) in items" :key="item.id" >
    <div class="row">
      <div class="col-md-3">
          <label type="label" :id="item.id" :name="item.name" >
          {{ item.name }} {{item.address}}
          </label>
        </div>
        <div class="col-md-2">
          <input :id="item.id + uid + '_kubik'" :disabled="!item.kubik ==''" :value="item.kubik" placeholder="Kubik" type="number" pattern="[0-9]+([\.,][0-9]+)?" step="0.001" name="kubik" @keyup="updateValueTon(item, $event.target.value)" class="form-control" />
        </div>
        <div class="col-md-2">
          <input :id="item.id + uid + '_ton'" :disabled="!item.ton ==''" :value="item.ton" placeholder="Ton" type="number" pattern="[0-9]+([\.,][0-9]+)?" step="0.001" name="ton" @keyup="updateValueKubik(item, $event.target.value)" class="form-control" />
        </div>
        <div class="col-md-2">
          <a v-if="(item.ton && item.kubik)" href="#" :id="item.id + 'removePlace'" @click.prevent="removePlace(item)">Ta bort</a>
          <a v-else href="#" id="addPlace" @click.prevent="addPlace(item)">Lägg till</a>
        </div>
        <div class="col-md-3">
          <Button label="Leveransställe" icon="pi pi-external-link" @click.prevent="customerPlaceDetails(item.id)" />
          <Button v-if="(item.comments.length > 0)" label="Kommentarer" class="p-button-warning" v-b-tooltip.hover :title="setComments(item.comments)" icon="pi pi-external-link" @click.prevent="openModal(item.customerPlaceId)" />
          <span v-if="item.onlyTruck"><i style="color:red;font-size:25px;top:6px;position:relative" class="pi pi-minus-circle"></i> Enbart lastbil</span>
          <span v-if="item.onlyTruck == false"><img style="width:50px" src="../assets/img/truckandtrailer.png"/> Lastbil och släp</span>
          <span v-if="item.washAtCustomer"><img style="width:15px;margin-left: 10px" src="../assets/img/water-drop.png"/> Sköljning</span>
          <span v-if="item.washAtCustomer == false"><img style="width:15px;margin-left: 10px" src="../assets/img/water-drop-not.png"/> Ej sköljning</span>
          <span v-if="item.docs"><Button class="p-button-warning" style="margin-left: 15px" title="Det finns kopplade dokument" icon="pi pi-file-pdf" @click.prevent="openModalDocs(item.docs)" /></span>
        </div>
      </div>
  </div>
  <div class="row fieldCheckBoxObjectArray">
    <div class="col-md-3">
      <p><strong>Totalt:</strong></p>
    </div>
    <div class="col-md-2">
      <p><span id="totalKubik">{{ calcKubik }}</span> kubik </p>
    </div>
    <div class="col-md-2">
      <p><span id="totalTon">{{ calcTon }}</span> ton</p>
    </div>
  </div>
</div>
</template>

<script>
import { isNil, clone } from 'lodash'
import { abstractField } from 'vue-form-generator'
import uuidv4 from 'uuid/v4'
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import { bus } from '../main'
export default {
  components: {
    Button,
    Dialog,
    bus
  },
  mixins: [abstractField],
  beforeMount () {
    if (isNil(this.value)) {
      this.value = []
    }
  },
  data () {
    return {
      uid: uuidv4(),
      displayModal: false,
      quantity: this.$props.model.Quantity.replace(',', '.')
    }
  },
  computed: {
    items: {
      get: function () {
        return this.schema.values
      },
      set: function (newValue) {
        return newValue
      }
    },
    calcKubik: {
      get: function () {
        let calcK = 0
        for (var i = 0; i < this.schema.values.length; i++) {
          if (this.schema.values[i].kubik !== '') {
            calcK = parseFloat(calcK) + parseFloat(this.schema.values[i].kubik.replace(',', ''))
          }
        }
        return calcK.toFixed(2)
      },
      set: function (newValue) {
        return newValue
      }
    },
    calcTon: {
      get: function () {
        let calcT = 0
        for (var i = 0; i < this.schema.values.length; i++) {
          if (this.schema.values[i].ton !== '') {
            calcT = parseFloat(calcT) + parseFloat(this.schema.values[i].ton.replace(',', ''))
          }
        }
        return calcT.toFixed(2)
      },
      set: function (newValue) {
        return newValue
      }
    }
  },
  methods: {
    openModal (id) {
      bus.$emit('showModal', id)
    },
    openModalDocs (docs) {
      bus.$emit('openModalDocs', docs)
    },
    customerPlaceDetails (id) {
      let routeData = this.$router.resolve({name: 'CustomerPlacesDetails', params: { id: id }})
      window.open(routeData.href, '_blank')
    },
    updateValueTon (currentItem, value) {
      const ton = document.getElementById(currentItem.id + this.uid + '_ton')
      const newValue = value * currentItem.density
      ton.value = newValue.toFixed(2)
    },
    updateValueKubik (currentItem, value) {
      const kubik = document.getElementById(currentItem.id + this.uid + '_kubik')
      const newValue = value * (1 / currentItem.density)
      kubik.value = newValue.toFixed(2)
    },
    addPlace (item) {
      var kubik = document.getElementById(item.id + this.uid + '_kubik').value
      var ton = document.getElementById(item.id + this.uid + '_ton').value
      const arr = clone(this.value)
      if (ton !== '' && kubik !== '') {
        this.calcKubik = parseFloat(this.calcKubik) + parseFloat(kubik.replace(',', ''))
        this.calcTon = parseFloat(this.calcTon) + parseFloat(ton.replace(',', ''))
        item.kubik = kubik
        item.ton = ton
      } else {
        let tonLeft = parseFloat(this.quantity) - this.calcTon
        let kubikLeft = tonLeft * (1 / item.density)
        item.kubik = kubikLeft.toFixed(2)
        item.ton = tonLeft.toFixed(2)
      }
      arr.push(item)
      bus.$emit('addedCustomerPlace', item)
      this.value = arr
    },
    removePlace (item) {
      this.calcKubik = parseFloat(this.calcKubik) - parseFloat(item.kubik.replace(',', ''))
      this.calcTon = parseFloat(this.calcTon) - parseFloat(item.ton.replace(',', ''))
      item.ton = ''
      item.kubik = ''
      const arr = clone(this.value)
      for (var i = arr.length - 1; i >= 0; --i) {
        if (arr[i].id === item.id) {
          arr.splice(i, 1)
        }
      }
      this.value = arr
      bus.$emit('removedCustomerPlace', item)
    },
    setComments (comments) {
      if (comments.length > 0) {
        let commentString = ''
        for (var i = 0; i < comments.length; i++) {
          commentString = commentString + comments[i].text
          if (i !== comments.length - 1) {
            commentString = commentString + ' -- '
          }
        }
        return commentString
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/vfg-custom-fields/fieldCheckboxObjectArray.vue